import { homeOf, isSolved, rowsField } from './board';
import { correctEdges } from './edges';
import { createSeededRandom } from './random';
import type { Board } from './types';

/** 拒绝采样：不是完成态，且不存在任何正确边。实测一次通过率 24%–37%。 */
/** n = 列数，rows = 行数（缺省 = n，方形）；同一 seed 的方形棋盘与以前完全相同 */
export function shuffle(n: number, seed: number, maxTries = 10000, rows = n): Board {
  if (!Number.isInteger(n) || n < 2) throw new Error(`shuffle: invalid n ${n}`);
  if (!Number.isInteger(rows) || rows < 2) throw new Error(`shuffle: invalid rows ${rows}`);
  const rng = createSeededRandom(seed);
  const N = n * rows;
  for (let attempt = 0; attempt < maxTries; attempt++) {
    const cells = Array.from({ length: N }, (_, i) => i);
    for (let i = N - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      [cells[i], cells[j]] = [cells[j], cells[i]];
    }
    const board: Board = { n, ...rowsField(n, rows), pos: cells.map((c) => homeOf(c, n)) };
    if (correctEdges(board).length === 0 && !isSolved(board)) return board;
  }
  throw new Error(`shuffle: no valid board after ${maxTries} tries (${n}×${rows}, seed=${seed})`);
}
